import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  scroll_container: {
    width: 'calc(100% + 4vw)',
    marginRight: '-2vw',
    marginLeft: '-2vw',
  },
}));
